import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private accessToken: string | null = null;

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }),
    withCredentials: true,
  };

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {}

  /**
   * Sets the access token for the user and store in localStorage
   * @param token The access token to set.
   */
  public setAccessToken(token: string): void {
    this.accessToken = token;
  }

  /**
   * Returns the access token.
   * @returns {string | null} The access token or null if it doesn't exist.
   */
  public getAccessToken = (): string | null => this.accessToken;

  /**
   * Clears the access token.
   */
  public clearAccessToken(): void {
    this.accessToken = null;
  }

  /**
   * Sends a POST request to the server to refresh the access token using the provided refresh token.
   * @returns An Observable that emits the response from the server.
   */
  public refreshToken(): Observable<any> {
    return this.http.post<any>(this.apiService.getRefreshTokenUrl(), {}, this.httpOptions);
  }
}
